import { useMemo } from 'react';
import { UserAttributesClient } from 'frontend-preferences-client';
import { registerQuery, useQuery } from 'data-fetching-client';
import Raven from 'raven-js';
import { getUserSettingDefaultValues } from './UserSettingKeys';
function parseSettingsValue(key, value) {
  // 0 and false are valid JSON.parse targets, but not null, undefined, or empty string
  if (value == null || value === '') {
    return null;
  }
  try {
    return JSON.parse(value);
  } catch (error) {
    Raven.captureException(error, {
      extra: {
        key,
        value
      }
    });
    return null;
  }
}
export const GET_USER_SETTINGS = 'GET_USER_SETTINGS';
export const GetUserSettingsQuery = registerQuery({
  fieldName: GET_USER_SETTINGS,
  args: [],
  fetcher: () => {
    const userAttributesClient = UserAttributesClient.forCaller('crm-object-board');
    const defaultValues = getUserSettingDefaultValues();
    return userAttributesClient.batchFetch(defaultValues).catch(error => {
      Raven.captureException(error, {
        level: 'error'
      });
      return defaultValues;
    });
  }
});
function useUserSettings() {
  const {
    data,
    loading,
    error
  } = useQuery(GetUserSettingsQuery, {
    variables: {},
    fetchPolicy: 'cache-first'
  });
  return useMemo(() => {
    let userSettings = null;
    if (data) {
      userSettings = data[GET_USER_SETTINGS];
    }
    return {
      data: userSettings,
      loading,
      error
    };
  }, [data, loading, error]);
}
export function useUserSetting(key) {
  const {
    data
  } = useUserSettings();
  const defaultValue = getUserSettingDefaultValues();
  return useMemo(() => {
    if (data) {
      return parseSettingsValue(key, data[key]);
    }
    return parseSettingsValue(key, defaultValue[key]);
  }, [key, data, defaultValue]);
}